var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showError && _vm.buefy === false
    ? _c(
        "div",
        {
          staticClass: "alert alert-warning error",
          class: { fixed: _vm.inline !== true },
          attrs: { role: "alert" },
        },
        [
          _vm.message
            ? _c("span", [_vm._v(_vm._s(_vm.message))])
            : _vm.currentError !== null
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.currentError.typeLabel) +
                    " - " +
                    _vm._s(_vm.currentError.message)
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isFlightPlan
            ? [
                _c(
                  "div",
                  { staticClass: "alert-close", on: { click: _vm.dismiss } },
                  [_c("fa", { attrs: { icon: "xmark" } })],
                  1
                ),
              ]
            : [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button" },
                    on: { click: _vm.dismiss },
                  },
                  [_c("span", [_vm._v("×")])]
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }